export enum VisitSignaturesEnum {
  CRC = 'CRC',
  SUBI = 'Sub-I',
  PI = 'PI',
}
